/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Details/view.blocks to change it.
import Name from './Name/index'
import PatientInfo from './PatientInfo/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Details({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/SimilarPatients/Content/Content/SimilarPerson/Person/Info/Details"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Details.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Name
  viewPath={`${viewPath}/Name`}
/>
<PatientInfo
  viewPath={`${viewPath}/PatientInfo`}
/>
</div>
{children}
</React.Fragment>)
}